import { FaChild, FaChevronRight } from "react-icons/fa";
import { GiShuttlecock, GiTrophy } from "react-icons/gi";
import { MdSchool } from "react-icons/md";

const programs = [
  {
    title: "Beginner",
    tagline: "Start with fundamentals and court awareness.",
    features: ["Grip and footwork", "Basic rally drills", "Confidence building"],
    icon: <MdSchool className="h-8 w-8 text-emerald-300" />,
  },
  {
    title: "Intermediate",
    tagline: "Sharpen consistency and match strategy.",
    features: ["Shot selection", "Conditioning", "Match simulation"],
    icon: <GiShuttlecock className="h-8 w-8 text-emerald-300" />,
  },
  {
    title: "Advanced",
    tagline: "Elevate speed, power and tactical precision.",
    features: ["Advanced footwork", "Tournament readiness", "Video analysis"],
    icon: <GiTrophy className="h-8 w-8 text-emerald-300" />,
  },
  {
    title: "Kids Coaching",
    tagline: "Fun, focused learning for young athletes.",
    features: ["Skill games", "Safety first", "Confidence growth"],
    icon: <FaChild className="h-8 w-8 text-emerald-300" />,
  },
];

const ProgramsSection = () => {
  return (
    <section id="programs" className="mx-auto max-w-7xl px-6 py-20 sm:px-8 lg:px-12">
      <div className="mb-12 max-w-3xl">
        <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">Training Programs</p>
        <h2 className="section-heading mt-4">Structured programs for every skill level.</h2>
        <p className="section-copy">Choose a tailored academy pathway designed for progress, performance and long-term growth.</p>
      </div>

      <div className="grid gap-6 xl:grid-cols-4">
        {programs.map((program) => (
          <div key={program.title} className="section-card group overflow-hidden transition hover:-translate-y-1 hover:border-emerald-400/20">
            <div className="flex items-center gap-4">
              <div className="rounded-3xl bg-slate-900/80 p-4">{program.icon}</div>
              <div>
                <p className="text-sm uppercase tracking-[0.32em] text-emerald-300">{program.title}</p>
                <h3 className="mt-3 text-2xl font-semibold text-white">{program.tagline}</h3>
              </div>
            </div>
            <ul className="mt-8 space-y-3 text-slate-400">
              {program.features.map((feature) => (
                <li key={feature} className="flex items-start gap-3">
                  <span className="mt-1 text-emerald-300"><FaChevronRight /></span>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProgramsSection;
